import { formatCurrency } from 'utils';

import { ShopMembership } from 'types';

export const getPaymentValues = (membership: ShopMembership) => {
  const startupFee = Number(membership?.startup_fee);
  const montlyFee = Number(membership?.montly_fee);

  if (startupFee === 0 && montlyFee === 0) {
    return ['FREE'];
  }
  if (startupFee > 0 && montlyFee === 0) {
    return [formatCurrency(startupFee)];
  }
  if (startupFee === 0 && montlyFee > 0) {
    return [`${formatCurrency(montlyFee)}/month`];
  }

  return [formatCurrency(startupFee), `${formatCurrency(montlyFee)}/month`];
};
